import * as React from "react";
function SvgTumblr(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" width={32} height={32} rx={6} />
      <path
        fill="#fff"
        d="M22.57 26.89h-3.71c-3.34 0-5.83-1.7-5.83-5.77V14.6H10v-3.53a6.57 6.57 0 004.9-6.18h3.46v5.6h4.05v4.11h-4.05v5.68c0 1.7.87 2.29 2.25 2.29h2v4.32"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTumblr);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
